module.exports = __webpack_public_path__ + "static/media/lafise-phone.d2c1e01d.svg";